import * as Pixi from "pixi.js";
import React from "react";
import { useFlags } from "../Providers/FeatureFlagProvider";

export const useIsV2Supported = (): boolean => {
  const flags = useFlags(["document-viewer-v2"]);

  const [isWebGPUSupported, setWebGPUSupported] =
    React.useState<boolean>(false); // fallback to v1

  React.useEffect(() => {
    Pixi.isWebGPUSupported().then((isSupported) => {
      setWebGPUSupported(isSupported);
    });
  }, []);

  return React.useMemo(() => {
    const isSupported = isWebGPUSupported || Pixi.isWebGLSupported();
    if (!isSupported) {
      console.warn("WebGL and WebGPU is not supported");
    }
    return flags["document-viewer-v2"].enabled && isSupported;
  }, [flags, isWebGPUSupported]);
};
